import { render, staticRenderFns } from "./PropostaSubscritor.vue?vue&type=template&id=1e99a432"
import script from "./PropostaSubscritor.vue?vue&type=script&lang=js"
export * from "./PropostaSubscritor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports